export const thousandsSeparators = (num: number) => {
  const numParts = num.toString().split('.')
  if (num >= 10000) {
    numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  }
  if (numParts[1] === '00') {
    return numParts[0]
  }
  return numParts.join('.')
}
